<template>
  <div class="wrap home-wrap flex-column">
    <topLink></topLink>
    <mu-infinite-scroll
      :loading="load"
      loadingText="拼命加载中"
      class="load"
      v-if="load"
    />
    <!-- 搜索框 -->
    <div class="input-box" :class="{ fixed: scrolled > 0 }">
      <input
        readonly
        class="serarch-input"
        type="text"
        name=""
        placeholder="搜索商品"
        @click="searchGood"
      />
    </div>
    <div class="flex-item homeWrapper" ref="homeWrapper" v-show="!load">
      <!-- banner广告轮播 -->
      <div class="banner">
        <swiper :options="swiperOption" ref="mySwiper1">
          <!-- 轮播图 -->
          <swiper-slide v-for="(item, index) in slides" :key="index">
            <div
              class="img-box"
              @click="linkFn(item.linkType, item.linkTarget)"
            >
              <v-image
                :width="720"
                :imagePath="item.imagePath && item.imagePath.imagePath"
              ></v-image>
            </div>
          </swiper-slide>
          <!-- 轮播切换 -->
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <!-- 品牌分类 -->
      <div class="sub-brand">
        <!-- <div class="brand-item square"  @click="linkFn('project','')">
          <img src="/static/images/project-icon.png" style="width:100%">
          <p>工厂直供</p>
        </div> -->
        <a class="brand-item square" href="tel:023-62797973">
          <img src="/static/images/project-icon.png" style="width: 100%" />
          <p>工厂直供</p>
        </a>
        <div class="brand-item square" @click="linkFn('fitting', '')">
          <img src="/static/images/icon_sgtd.jpg" style="width: 100%" />
          <p>诚邀合伙人</p>
        </div>
        <div
          class="brand-item square"
          v-for="(item, index) in brandCates"
          :key="index"
          @click="linkFn(item.cates.linkType, item.cates.linkTarget)"
        >
          <v-image
            :imagePath="
              item.cates &&
              item.cates.imagePath &&
              item.cates.imagePath.imagePath
            "
            :width="120"
            :height="120"
            :imgStyle="{ margin: '0 auto' }"
          ></v-image>
          <p>{{ item.cates.linkName }}</p>
        </div>
        <div class="brand-item square" @click="linkFn('oa', '')">
          <div
            class="square"
            style="
              width: 100%;
              font-size: 0;
              border-radius: 0.333333rem;
              overflow: hidden;
            "
          >
            <img src="/static/images/oaLogo.jpg" style="width: 100%" />
          </div>
          <p>办公门户</p>
        </div>
        <div class="brand-item square" @click="$router.push('/main/diyPage')">
          <div
            class="square"
            style="
              width: 100%;
              font-size: 0;
              border-radius: 0.333333rem;
              overflow: hidden;
            "
          >
            <img src="/static/images/diyLogo.png" style="width: 100%" />
          </div>
          <p>DIY</p>
        </div>

        <div
          class="brand-item square"
          @click="$router.push('/main/install-study')"
        >
          <div
            class="square"
            style="
              width: 100%;
              font-size: 0;
              border-radius: 0.333333rem;
              overflow: hidden;
              background-color: yellow;
            "
          >
            <img src="/static/images/install-study.png" style="width: 100%" />
          </div>
          <p>安装指导</p>
        </div>
      </div>
      <!-- 广告banner -->
      <!-- <div class="banner-single"></div> -->
      <!-- 系列门 -->
      <!-- 
      <div class="series-box">
        <div class="series-item" v-for="i in 6">
          <div class="content">
            <p class="header">厨卫系列</p>
            <p class="name">最高优惠50元起</p>
            <p class="price">¥ 3999起</p>
          </div>
          <div class="img"></div>
        </div>
      </div> 
      -->
      <!-- VR展示广告 -->
      <!-- <div class="banner-single"></div> -->
      <!-- 精品推荐 -->
      <div class="recommend">
        <h2>精品推荐</h2>
        <div class="banner-recommend">
          <swiper :options="comSwiperOption" ref="mySwiper2">
            <!-- 这部分放你要渲染的那些内容 -->
            <swiper-slide v-for="(item, index) in boutiques" :key="index">
              <div class="img-box" @click="viewGoodsDetail(item)">
                <div class="img">
                  <v-image
                    :width="250"
                    :height="250"
                    :imagePath="item.imagePath && item.imagePath.imagePath"
                  ></v-image>
                </div>
                <p class="title ellipsis">{{ item.goodsName }}</p>
                <p class="money">
                  <samp v-if="item.goodsPrice > 0">¥</samp>
                  {{ item.goodsPrice > 0 ? item.goodsPrice : item.goodDesc }}
                  <span v-if="item.unitPrice > 0">¥ {{ item.unitPrice }}</span>
                </p>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <!-- 最新消息发布 -->
      <!-- 
      <div class="news">
        <swiper :options="newsSwiperOption"  ref="mySwiper3">
                <swiper-slide v-for="item,index in 7" :key="index">
            <div class="news-item ellipsis">
              <samp>最新消息发布：</samp>
              美心·蒙迪  下单最高优惠500元，还可抽奖下单最高优惠500元，还可抽奖
            </div>
                </swiper-slide>
            </swiper>
      </div> 
      -->
      <!-- 商品楼层：品牌分类 -->
      <div class="brand-product" v-for="(item, index) in floors">
        <a
          class="banner-product"
          v-if="item.itemType == 99"
          @click="linkFn(item.floorInfo.linkType, item.floorInfo.linkTarget)"
        >
          <v-image
            :width="720"
            :imagePath="
              item.floorInfo &&
              item.floorInfo.imagePath &&
              item.floorInfo.imagePath.imagePath
            "
            :eventparam="item"
          ></v-image>
        </a>
        <a
          class="header"
          v-if="item.floorInfo.goods && item.floorInfo.goods.length"
          @click="linkFn(item.floorInfo.linkType, item.floorInfo.storeId)"
        >
          <span class="floatL brandName">
            {{ item.floorName }}
          </span>
          <span class="floatR arrow">更多</span>
          <div class="clearfix"></div>
        </a>
        <div class="product">
          <div
            class="product-item square"
            v-for="(goods, index) in item.floorInfo.goods"
          >
            <v-image
              :width="250"
              :height="250"
              :titleText="goods.goodsName"
              :imagePath="goods.imagePath && goods.imagePath.imagePath"
              :moneyText="
                goods.goodsPrice > 0 ? goods.goodsPrice : goods.priceDesc || ''
              "
              :orginalCost="goods.unitPrice"
              @eventclick="viewGoodsDetail"
              :eventparam="goods"
            >
              <template slot="money">
                {{ goods.goodsPrice > 0 ? goods.goodsPrice : goods.priceDesc }}
              </template>
              <template slot="orginalCost">{{ goods.unitPrice }}</template>
            </v-image>
          </div>
        </div>
      </div>
      <!-- 底部广告以及客服电话 -->
      <div class="brand-product bottom">
        <a class="header" @click="gotosunhomeList" v-if="ShareGoods.length > 0">
          <span class="floatL brandName">晒家分享</span>
          <span class="floatR arrow">更多</span>
          <div class="clearfix"></div>
        </a>
        <div class="floatL left-advertise" v-for="item in ShareGoods">
          <div class="img" @click="gotoSunhomeDetail(item.shareId)">
            <v-image
              :titleText="item.shareContent"
              :imagePath="item && item.imagePath && item.imagePath.imagePath"
            ></v-image>
            <p class="userName ellipsis">来自 {{ item.shareBy }} 的评价</p>
            <p class="style-box">
              <span class="style ellipsis">
                <template v-for="sub in item.tags">
                  {{ sub.linkName }}&nbsp;
                </template>
              </span>
              <span class="price ellipsis" v-if="item.totalPrice > 0">
                {{ item.totalPrice }}元
              </span>
            </p>
          </div>
        </div>
        <!--   <div class="floatR right-advertise">
          <div class="advertise-box">
            <div class="adver-box">
              <div class="img-box" v-for="i in 5">
                <v-image titleText="超级喜欢！的产品我都只" :imagePath="require('@assets/zyImages/u276.jpeg')" moneyText="2900"></v-image>
              </div>
            </div>
          </div>
          <a href="tel:400-823-2777" class="link-phone">客服服务</a>
          <a href="tel:400-823-2777" class="phoneNum">400-832-2777</a>
        </div> -->
        <div class="clearfix"></div>
      </div>
    </div>
    <menus></menus>
  </div>
</template>
<script type="text/javascript">
import { swiper, swiperSlide } from "vue-awesome-swiper";
import menus from "@components/menus/menus";
import topLink from "@components/topLink/topLink";
import image from "@components/image/image";
import Constant from "@/Constant";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      defaultBanner: Constant.defaultVal.defaultBanner,
      slides: [], //焦点幻灯banner
      brandCates: [], //品牌分类
      boutiques: [], //精品推荐
      floors: [],
      swiperOption: {
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        /*notNextTick: true,  */
        pagination: ".swiper-pagination",
        autoplay: 10000,
        autoplayDisableOnInteraction: false,
      },
      comSwiperOption: {
        slidesPerView: 2.5,
        slidesPerGroup: 2,
        autoplay: 10000,
        loop: false,
        autoplayDisableOnInteraction: false,
      },
      newsSwiperOption: {
        direction: "vertical",
        autoplay: 10000,
        loop: true,
        autoplayDisableOnInteraction: false,
      },
      scrolled: 0, //监听滚动事件
      load: true,
      ShareGoods: [], //晒家分享列表
    };
  },
  updated() {
    if (!this.$route.meta.savePosition) {
      return;
    }
    this.$nextTick(function () {
      this.$refs.homeWrapper.scrollTop = this.$route.meta.savePosition;
      setTimeout(() => {
        this.$route.meta.savePosition = 0;
      }, 500);
    });
  },
  methods: {
    ...mapActions({
      getHomeSlide: "getHomeSlide",
      getBrandCates: "getBrandCates",
      getAdBanners: "getAdBanners",
      getRecomGoods: "getRecomGoods",
      getVrBanner: "getVrBanner",
      getBoutiqueGoods: "getBoutiqueGoods",
      getNewMessages: "getNewMessages",
      getHomeFloorInfos: "getHomeFloorInfos",
      getMainShareGoods: "getMainShareGoods",
    }),

    onScroll() {
      /*this.scrolled = document.querySelectorAll('.homeWrapper')[0].scrollTop;*/
      this.scrolled = this.$refs.homeWrapper.scrollTop;
    },
    gotosunhomeList() {
      this.$route.meta.savePosition = this.$refs.homeWrapper.scrollTop;
      this.$router.push({ path: "/main/sunhomelist" });
    },
    gotoSunhomeDetail(shareId) {
      this.$route.meta.savePosition = this.$refs.homeWrapper.scrollTop;
      this.$router.push({ path: "/main/sunhomedetail?shareId=" + shareId });
    },
    goDeatil() {
      alert(1);
      this.$route.meta.savePosition = this.$refs.homeWrapper.scrollTop;
    },
    //搜索商品
    searchGood() {
      this.$router.push({ path: "/main/allSearch" });
    },

    _initView() {
      //  1.焦点幻灯
      this.getHomeSlide().then((res) => {
        console.log("getHomeSlide", res);
        this.slides = res;
      });

      //  2.品牌分类
      this.getBrandCates([4]).then((res) => {
        console.log("getBrandCates", res);
        this.brandCates = res;
      });

      //  3.广告banner
      /*this.getAdBanners().then(res=>{
                    console.log('getAdBanners',res);
                    this.navBanners = res;
                  });*/

      //  4.系列推荐
      /*this.getRecomGoods().then(res=>{
                    console.log('getRecomGoods',res);
                    this.navBanners = res;
                  });*/

      //  5.VR展示广告
      /*this.getVrBanner().then(res=>{
                    console.log('getVrBanner',res);
                    this.navBanners = res;
                  });*/

      //  6.精品推荐
      this.getBoutiqueGoods().then((res) => {
        console.log("getBoutiqueGoods", res);
        this.boutiques = res;
      });

      //  7.最新消息
      /*this.getNewMessages().then(res=>{
                    console.log('getNewMessages',res);
                    this.navBanners = res;
                  });*/
      //  8.商品楼层(暂用WEB)
      this.getHomeFloorInfos(4).then((res) => {
        console.log("getHomeFloorInfos", res);
        this.floors = res;
        this.load = false;
      });
      //  9.晒家分享
      this.getMainShareGoods().then((res) => {
        this.ShareGoods = res;
      });
    },

    //浏览商品详情
    viewGoodsDetail(goods) {
      if (goods && goods.goodsId) {
        this.$route.meta.savePosition = this.$refs.homeWrapper.scrollTop;
        this.$router.push({
          path:
            "/main/goodsDetail?goodsId=" +
            goods.goodsId +
            "&skuId=" +
            (goods.skuId || 0) +
            "&storeId=" +
            goods.storeId,
        });
      }
    },
  },
  computed: {
    /*goodsFloors(){
                  return this.floors.filter(item => {
                    return item.itemType == 1;
                  });
                },*/
    /*adFloors(){
                  return this.floors.filter(item => {
                    return item.itemType == 99;
                  });
                }*/
  },
  watch: {},
  mounted() {
    this.$nextTick(function () {
      console.log(this.$refs);
      /*document.querySelectorAll('.homeWrapper')[0].addEventListener('scroll', this.onScroll)*/
      this.$refs.homeWrapper.addEventListener("scroll", this.onScroll);
    });
  },
  created() {
    this._initView();

    console.log(this.defaultBanner);
  },
  components: {
    menus,
    topLink,
    "v-image": image,
    swiper,
    swiperSlide,
  },
};
</script>
<style lang="scss" rel="stylesheet/scss">
@import "src/common/sass/mixin.scss";
.home-wrap {
  .swiper-container {
    height: 100%;
  }
  .flex-item {
    position: relative;
  }
  .serarch-input {
    display: block;
    width: 93%;
    height: 0.7rem;
    margin: 0 auto;
    border-radius: 0.675rem;
    color: #fff;
    @include font-dpr(13.5px);
    @include sInput(red, center, #fff);
    background: url(/static/images/productList_search_white@3x.png) no-repeat
      0.25rem center;
    background-size: 0.45rem;
    background-color: rgba(0, 0, 0, 0.3);
  }
  .input-box {
    width: 100%;
    padding: 0.1rem 0;
    position: absolute;
    top: 0.7rem;
    z-index: 2;
    &.fixed {
      position: absolute;
      /*top: 0.7rem;*/
      background: #fff;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.09);
      .serarch-input {
        @include sInput(red, center, #999999);
        color: #999999;
        background: url(/static/images/productList_search@3x.png) no-repeat
          0.25rem center;
        background-size: 0.45rem;
        background-color: rgba(239, 239, 239, 1);
      }
    }
  }
  .banner {
    min-height: 0.5rem;
    .swiper-pagination {
      width: 100%;
      bottom: 0.275rem;
      text-align: center;
      > span {
        width: 0.15rem;
        height: 0.15rem;
        margin: 0 0.075rem;
        border-radius: 50%;
        background: #fff;
        opacity: 1;
        &.swiper-pagination-bullet-active {
          width: 0.3rem;
          border-radius: 0.2rem;
        }
      }
    }
  }
  .sub-brand {
    background: #fff;
    font-size: 0;
    .brand-item {
      display: inline-block;
      width: 25%;
      padding: 0.2rem 0.5rem;
      text-align: center;
      @include font-dpr(12px);
      > img {
        width: 1.1rem;
        margin-bottom: 0.075rem;
        margin: 0 auto;
      }
      > p {
        color: #666666;
        white-space: nowrap;
      }
    }
  }
  .banner-single {
    height: 1rem;
    background: #bdbdbd;
  }
  .series-box {
    margin: 0.2rem 0;
    position: relative;
    font-size: 0;
    .series-item {
      display: inline-block;
      width: 50%;
      background: #fff;
      height: 2.625rem;
      position: relative;
      overflow: hidden;
      margin-bottom: 1px;
      > div {
        display: inline-block;
      }
      .content {
        width: 60%;
        margin: 0.25rem 0.2rem;
        @include font-dpr(12px);
        color: #999999;
        .header {
          @include font-dpr(14px);
          color: #333333;
        }
        .price {
          color: #e60012;
        }
      }
      .img {
        width: 1.025rem;
        height: 1.875rem;
        vertical-align: bottom;
        background: red;
        position: absolute;
        bottom: 0;
      }
    }
    &:before {
      content: "";
      display: inline-block;
      width: 2px;
      background: $cBgColor;
      position: absolute;
      top: 0;
      left: 50%;
      bottom: 0;
      z-index: 1;
    }
  }
  .recommend {
    margin: 0.2rem 0;
    padding-bottom: 0.3rem;
    background: #ffffff;
    > h2 {
      padding: 0.3rem 0.2rem;
      @include font-dpr(14px);
      color: #333;
      border-bottom: 1px solid #ddd;
    }
    .banner-recommend {
      .swiper-slide {
        padding-top: 0.25rem;
        border-right: 1px solid #ddd;
      }
      .img-box {
        padding: 0 0.25rem;
        .img {
          height: 3rem;
          width: 3rem;
          margin: 0 auto;
          overflow: hidden;
          text-align: center;
        }
        .title {
          margin: 0.25rem 0 0.3rem 0;
          text-align: center;
        }
        .money {
          color: #e60012;
          text-align: center;
          @include font-dpr(12px);
          > samp {
            padding-right: 0.075rem;
            @include font-dpr(10px);
          }
          > span {
            margin-left: 0.25rem;
            @include font-dpr(9px);
            color: #999999;
            position: relative;
            @include line(0.2rem, 0, #999999, 1px);
            &:after {
              margin-top: -0.025rem;
            }
          }
        }
      }
    }
  }
  .news {
    height: 0.75rem;
    line-height: 0.75rem;
    background: #fff;
    margin-bottom: 0.2rem;
    .news-item {
      padding: 0.025rem 0.2rem 0 0.75rem;
      color: #333333;
      @include font-dpr(12px);
      > samp {
        color: #999999;
      }
      background: url(/static/images/home_note_3x.png) no-repeat 0.2rem center;
      background-size: 0.35rem auto;
    }
  }
  .brand-product {
    margin-bottom: 0.2rem;
    .header {
      display: block;
      padding: 0.35rem 0.1rem;
      background: #fff;
      @include font-dpr(13px);
      > span {
        line-height: 0.55rem;
      }
      > .brandName {
        padding-left: 0.125rem;
        border-left: 4px solid #d0021b;
        @include font-dpr(18px);
        color: #444444;
      }
      > .arrow {
        color: #808080;
        padding-right: 0.375rem;
        position: relative;
        @include arrow(#808080, right, 0.25rem, 1px, 0.075rem);
      }
    }
    .product {
      padding: 0 0.05rem;
      background: #fff;
      .product-item {
        display: inline-block;
        width: 50%;
        vertical-align: top;
        .image-wrap {
          padding: 0 0.05rem;
        }
      }
    }
    .banner-product {
      /* height: 1.0rem; */
      margin-top: 0.2rem;
      background: #bdbdbd;
    }
  }
  .bottom {
    margin-bottom: 0.2rem;
    background: #fff;
    .floatL {
      width: 50%;
    }
    .left-advertise {
      border-right: 1px solid #ddd;
      > .img {
        padding: 0.25rem;
        .image-wrap {
          .img {
            height: 2.95rem;
            overflow: hidden;
          }
        }
      }
      .title {
        text-align: left;
        margin: 0.25rem 0.1rem;
        color: #666666;
      }
      .userName {
        padding: 0.35rem 0.1rem 0.35rem 0.1rem;
        color: #999999;
      }
      .style-box {
        padding: 0 0.1rem 0 0.1rem;
        font-size: 0;
        > span {
          display: inline-block;
          vertical-align: middle;
          @include font-dpr(12px);
          &.style {
            width: 67%;
            color: #333333;
          }
          &.price {
            width: 33%;
            color: #e60012;
            text-align: right;
            white-space: nowrap;
          }
        }
      }
    }
    .right-advertise {
      .advertise-box {
        overflow-x: auto;
        > div.adver-box {
          white-space: nowrap;
          -webkit-overflow-scrolling: touch;
        }
      }
      .img-box {
        display: inline-block;
        width: 2.7rem;
        margin-right: 0.05rem;
        white-space: normal;
        .image-wrap {
          .img {
            height: 2.7rem;
            text-align: center;
            &:before {
              content: "";
              display: inline-block;
              height: 100%;
              vertical-align: middle;
            }
            img {
              display: inline-block;
              /* width: 1.05rem;
                            height: 2.25rem; */
              vertical-align: middle;
            }
          }
        }
        .title {
          margin: 0.125rem 0.125rem 0.2rem 0.125rem;
          color: #666666;
          @include font-dpr(10px);
        }
      }
      .link-phone,
      .phoneNum {
        display: block;
        text-align: center;
        @include font-dpr(14px);
        color: #333333;
      }
      .link-phone {
        padding: 0.25rem 0;
        text-indent: 0.5rem;
        background: url(/static/images/ic_service_3x.png) no-repeat 30% center;
        background-size: 0.4rem auto;
      }
      .phoneNum {
        color: #f5a623;
        margin-bottom: 0.3rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// home.vue?630ff51c